// Структурный клиентский лог — замена голому `console.*` в прод-коде
// (rules/code-quality.md п.25, rules/logging.md).
//
// На сервере логгер — Pino; на клиенте единственный канал, который переживает
// прод, — Hawk (`captureClientError`). Голый `console.error` в браузере видит
// только тот, у кого открыт DevTools, то есть по факту никто: потерянный чанк
// лекции или сорвавшийся finalize исчезали бесследно.
//
// Разделение каналов:
//   logClientError — что-то сломалось и это надо чинить → Hawk + dev-console.
//   logClientWarn  — деградация, работа продолжается → только dev-console.
//     В Hawk не шлём намеренно: у него нет уровня warn, и фоллбеки
//     (capacitor-адаптер недоступен, pause не доехал до бэка) забили бы
//     error-канал шумом. Если деградация становится продуктово значимой —
//     ей нужен не warn, а событие аналитики из типизированного каталога
//     (`@studyhub/shared/analytics`) либо видимый маркер в UI
//     (rules/logging.md §13a).

import { captureClientError } from "@/lib/observability";

/** Ошибка: уходит в Hawk с контекстом, в dev дублируется в консоль. */
export function logClientError(
	message: string,
	err?: unknown,
	ctx?: Record<string, unknown>,
): void {
	captureClientError(err ?? new Error(message), { message, ...ctx });
	if (import.meta.env.DEV) {
		// biome-ignore lint/suspicious/noConsole: dev-дубль поверх Hawk; ветка вырезается прод-сборкой по import.meta.env.DEV
		console.error(message, err, ctx);
	}
}

/** Деградация: продолжаем работать, в проде молчим (см. шапку файла). */
export function logClientWarn(message: string, err?: unknown, ctx?: Record<string, unknown>): void {
	if (import.meta.env.DEV) {
		// biome-ignore lint/suspicious/noConsole: ветка живёт только в dev-сборке, в проде вырезается по import.meta.env.DEV
		console.warn(message, err, ctx);
	}
}
